// Este codigo fue generado por Github Copilot Chat
import {
  Component,
  EventEmitter,
  Input,
  Output,
  HostListener,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from '../avatar/avatar.component';

export interface DropdownItem<T = string> {
  label: string;
  value: T;
  icon?: string;
  // Opcionales para compatibilidad con avatar
  name?: string;
  lastName?: string;
  email?: string;
}

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, AvatarComponent],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnChanges {
  @Input() items: DropdownItem[] = [];
  @Input() position = 0;
  @Input() useAvatar = true;
  @Input() placeholder = 'Seleccionar';
  @Input() value: any = null;
  @Output() selectItem = new EventEmitter<DropdownItem>();

  isOpen = false;
  selectedItem: DropdownItem | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] || changes['items']) {
      this.updateSelectedItem();
    }
  }

  private updateSelectedItem(): void {
    if (this.value !== null && this.value !== undefined && this.value !== '') {
      const found = this.items.find((item) => item.value === this.value);
      if (found) {
        this.selectedItem = found;
      }
    } else {
      this.selectedItem = null;
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onSelect(item: DropdownItem) {
    this.selectedItem = item;
    this.isOpen = false;
    this.selectItem.emit(item);
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-wrapper')) {
      this.isOpen = false;
    }
  }

  getDisplayText(item: DropdownItem): string {
    if (item.name && item.lastName) {
      return `${item.name} ${item.lastName}`;
    }
    return item.label;
  }

  get displayValue(): string {
    return this.selectedItem
      ? this.getDisplayText(this.selectedItem)
      : this.placeholder;
  }

  get hasValue(): boolean {
    return this.selectedItem !== null;
  }
}
// Este codigo fue generado por Github Copilot Chat
